{
  "instances": {
    "httpexchanges": {
      "label": "HTTP 交換",
      "chart": {
        "avg_time": "平均時長",
        "max_time": "最大時長",
        "status_4xx": "4xx 狀態碼",
        "status_5xx": "5xx 狀態碼",
        "successful_requests": "成功請求數",
        "total_requests": "總請求數"
      },
      "limit": "限制",
      "filter": {
        "client_errors": "用戶端錯誤",
        "exclude_actuator": "排除 {actuator}/**",
        "server_errors": "伺服器錯誤",
        "success": "成功"
      },
      "method": "方法",
      "status": "狀態",
      "time": "時長",
      "timestamp": "時間戳記",
      "uri": "路徑"
    }
  }
}
